"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PanelInputWithStep = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _row = _interopRequireDefault(require("../row"));

var _col = _interopRequireDefault(require("../col"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// ShpmtcDesign Components
// Style
var PanelInputWithStep = function PanelInputWithStep(_ref) {
  var topBloc = _ref.topBloc,
      leftBloc = _ref.leftBloc,
      rightBloc = _ref.rightBloc;
  var topBlocObj = topBloc !== null ? topBloc : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-inputWithStep"
  }, topBlocObj, /*#__PURE__*/_react.default.createElement(_row.default, {
    gutter: 40,
    type: "flex",
    justify: "space-around",
    align: "top"
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    sm: 24,
    md: 9
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "panel-inputWithStep__left"
  }, leftBloc)), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    sm: 24,
    md: 15
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "panel-inputWithStep__right"
  }, rightBloc))));
};

exports.PanelInputWithStep = PanelInputWithStep;
PanelInputWithStep.defaultProps = {
  topBloc: null
};
PanelInputWithStep.propTypes = {
  topBloc: _propTypes.default.node,
  leftBloc: _propTypes.default.node.isRequired,
  rightBloc: _propTypes.default.node.isRequired
};